export default __webpack_public_path__ + "static/media/carousel-1.d150fdc3.jpg";